import script from "./Startup.vue?vue&type=script&setup=true&lang=ts"
export * from "./Startup.vue?vue&type=script&setup=true&lang=ts"

import "./Startup.vue?vue&type=style&index=0&id=7fa1a2c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa1a2c2"]])

export default __exports__